import { useSelector } from "react-redux";
import { useMemo } from "react";

const useCommentSelector = ({ domain }) => {
    const isProject = domain === "PROJECT";

    const resourceData = useSelector((state) =>
        isProject ? state.commonComments.resourceData : state.comments.resourceData,
    );
    const comments = useSelector((state) =>
        isProject ? state.commonComments.comment : state.comments.comment,
    );
    const threads = useSelector((state) =>
        isProject ? state.commonComments.thread : state.comments.thread,
    );
    const selectedThreadId = useSelector((state) =>
        isProject ? state.commonComments.selectedThreadId : state.comments.selectedThreadId,
    );
    const selectedCommentId = useSelector((state) =>
        isProject ? state.commonComments.selectedCommentId : state.comments.selectedCommentId,
    );
    const hasLinkThreadLogicExecuted = useSelector((state) =>
        isProject ? state.commonComments.hasLinkThreadLogicExecuted : state.comments.hasLinkThreadLogicExecuted,
    );
    const isEditingCommentId = useSelector((state) =>
        isProject ? state.commonComments.isEditingCommentId : state.comments.isEditingCommentId,
    );
    const isLinkCommentUsed = useSelector((state) =>
        isProject ? state.commonComments.isLinkCommentUsed : state.comments.isLinkCommentUsed,
    );
    const uploadingComments = useSelector((state) =>
        isProject ? state.commonComments.uploadingComments : state.comments.uploadingComments,
    );

    const selectedComment = useMemo(() => {
        if (!comments?.data?.results?.length || !selectedCommentId) return null;
        return comments.data.results.find((comment) => comment.id === selectedCommentId);
    }, [comments?.data, selectedCommentId]);

    const selectedThread = useMemo(() => {
        if (!resourceData || !selectedThreadId) return null;
        return resourceData.results?.find((thread) => thread.id === selectedThreadId);
    }, [resourceData, selectedThreadId]);

    return {
        resourceData,
        comments,
        threads,
        selectedThreadId,
        selectedCommentId,
        hasLinkThreadLogicExecuted,
        isEditingCommentId,
        selectedComment,
        selectedThread,
        isLinkCommentUsed,
        uploadingComments,
    };
};

export default useCommentSelector;
